import {goToByScroll} from "./go-to-by-scroll";
import {scrollPos} from './check-scroll';

const _window = $(window);
const body = $('body');

/**
 * Go to by scroll buttons
 */

$('.hero-home__scroll-down').on('click', function () {
	goToByScroll($('.sezione-1'));
});


/**
 * Hide .contact-tools-toggle when the end of the page is reached
 */
const contactToolsToggle = $('.contact-tools-toggle');

setContactToolsToggleVisibility();

function setContactToolsToggleVisibility() {

	if (scrollPos > $(document).height() - _window.height() - 200)
	{
		contactToolsToggle.addClass('hidden');
	}
	else
	{
		contactToolsToggle.removeClass('hidden');
	}

	requestAnimationFrame(() => setContactToolsToggleVisibility());
}



/**
 * ON LOAD
 */

/*_window.on('load', function (event) {

});*/



/**
 * ON RESIZE
 */

/*_window.on('resize', function (event) {

	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			$(this).trigger('resizeEnd');
		}, 200);
	}

});*/



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
/*_window.on('resizeEnd', function () {

});*/



/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/